import type { MiddlewareRequestParams } from '../utils/mappers/i3/i3-documents-mapper';

const localePattern = /^([a-z]{2})_([A-Z]{2})$/;

export const getLocale = (el) => {
    const locale = Object.keys(el).filter((item) =>
      item.match(localePattern)
    )[0];
    return locale;
};

const countryMappingObject: { [key: string]: string } = {
  'uk': 'gb'
};

// TODO: need to refactor this function to make use of DateFormattingStrategyFallback.getLocale
export const getLocaleCode = (
  params: MiddlewareRequestParams
): string | null => {
    const { language, country } = params;
    const countryCode = countryMappingObject?.[country] ?? country ?? '';

    if(!language || !countryCode) return undefined;

    return `${language}-${country.toUpperCase()}`;
};